//@flow
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Draggable from 'react-draggable';
import '../../../../css/react-draggable/css/styles.css';
import IconClose from '../../../../icons/exit.svg';
import OlMap from 'ol/map';
import customControl from './customControl';
import { translate } from "react-i18next";
import LayerList from './LayerList';
import layerListIcon from '../../../../icons/layers.svg';

const PopupWindow = styled.div`
  background: #fff;
  border-radius: 3px;
  margin: 10px;
  float: left;
  z-index: 2;
  pointer-events: auto;
  position: absolute;
  top: 5px;
  right: 30px;
  width: 200px;
  max-height: 250px;
  height: 100%;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.4);
`;

const PopupHeader = styled.div`
  background-color: #265a9c;
  border-radius: 3px 3px 0 0;
  height: 24px;
  display: flex;
  justify-content: space-between;
  text-align: center;
  color: white;
  font-size: 12px;
  font-family: Open Sans, sans-serif;
  align-items: center;
  padding-left: 5px;
`;

const CloseButton = styled.button`
  display: flex;
  align-items: center;
  height: 100%;  
  background-color: transparent;
  border: none;

  :hover {
    -webkit-box-shadow: 0px 0px 3px 1px rgba(0,0,0,0.14);
    box-shadow: 0px 0px 3px 1px rgba(0,0,0,0.14);
  }
  img {
    height: 18px;
  }
`;

const CloseIcon = styled.img`
`;

const LayerListWrapper = styled.div`
  height: calc(100% - 24px);
  overflow-y: auto;
`;

type LayerListPopupState = {
  visible: boolean,
  control: customControl
}

type LayerListPopupProps = {
  olMap: OlMap,
  t: (s: string) => string,
  selected: string,
};

export class LayerListPopup extends React.Component<LayerListPopupProps, LayerListPopupState> {

  constructor(props) {
    super(props);
    const { olMap, t, selected }: LayerListPopupProps = props;

    // dodanie przycisku map bazowych
    const layerListControl = new customControl({
      onClick: this.onLayerListButtonClick,
      className: 'ol-layerlist-button',
      title: t('Layer list'),
      innerHTML: '<img width="20px" height="20px" src=' + layerListIcon + '></img>',
      parent: this
    });
    olMap.addControl(layerListControl);

    if (selected === 'default') {
      const node = layerListControl.ref;
      node.style.display = 'none';
    }

    this.state = {
      layersVisibilityDictionary: {},
      visible: false,
      control: layerListControl,
    };
  }

  onLayerListButtonClick(mapComponent) {
    mapComponent.setState({
      visible: !mapComponent.state.visible
    });
  }

  close(): void {
    this.setState({
      visible: false
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const prevSelected = prevProps.selected;
    const { selected, t } = this.props;
    const node = this.state.control.ref;
    if (prevSelected === 'default' && selected !== 'default') {      
      node.style.display = 'block';
    }
    if (selected === 'default') {
      node.style.display = 'none';
    }
    node.title = t('Layer list');
  }

  render(): React.Node {
    const { t, selected } = this.props;
    if (this.state.visible && selected !== 'default') {
      return (
        <Draggable bounds="parent"
          defaultPosition={{ x: -10, y: -5 }}
          grid={[1, 1]}>
          <PopupWindow>
            <PopupHeader>
              {t('Layer list')}
              <CloseButton onClick={() => this.close()}>
                <CloseIcon src={IconClose} />
              </CloseButton>
            </PopupHeader>
            <LayerListWrapper>
              <LayerList />
            </LayerListWrapper>
          </PopupWindow>
        </Draggable>
      );
    } else {
      return null;
    }
  }
};

const mapStateToProps = state => ({
  selected: state.modules.get('selected'),
});

export default translate("translations")(connect(mapStateToProps)(LayerListPopup));


// WEBPACK FOOTER //
// ./src/containers/content/map/popups/LayerListPopup.jsx